import Axios from "axios";
import React, { useContext } from "react";
import { configContext } from "../config-provider";
import { Spin } from "../loading";
// import { BarChart } from "../bar-chart";
import { LineChart } from "../line-chart";
// import { PieChart } from "../pie-chart";
// import { latestMonth } from "../../utils";

interface MaintenanceOverviewProps {}

interface State {
  lineChart: unknown[];
  pieChart: unknown[];
  barChart: unknown[];
  loading: boolean;
}

export const MaintenanceOverview: React.FC<MaintenanceOverviewProps> = (
  props
) => {
  const { disableBollard, dataStartMonth } = useContext(configContext);
  const [state, setState] = React.useState<State>({
    lineChart: [],
    pieChart: [],
    barChart: [],
    loading: false,
  });

  React.useEffect(() => {
    setState({ ...state, loading: true });
    Axios.get(`/maintenance/overview`, { params: { from: dataStartMonth } })
      .then((res) => {
        const { lineChart, pieChart, barChart } = res.data;

        setState({
          ...state,
          lineChart: [
            { label: "Lamppost", data: lineChart[0] },
            ...(disableBollard ? [] : [{ label: "Bollard", data: lineChart[1] }]),
            { label: "Controller", data: lineChart[2] },
            { label: "Cable", data: lineChart[3] },
            { label: "GSDS", data: lineChart[4] },
          ],
          pieChart: disableBollard ? pieChart.filter((_: any, i: number) => i !== 1) : pieChart,
          barChart: [
            { label: "Lamppost", data: barChart[0] },
            ...(disableBollard ? [] : [{ label: "Bollard", data: barChart[1] }]),
            { label: "Controller", data: barChart[2] },
            { label: "Cable", data: barChart[3] },
            { label: "GSDS", data: barChart[4] },
          ],
        });
      })
      .finally(() => {
        setState((prev) => ({ ...prev, loading: false }));
      });
  // eslint-disable-next-line
  }, []);

  return (
    <div className="overview full-height">
      <span className="title">maintenance overview</span>

      <div className="contract">
        {/* <span className="title">This Contract</span> */}

        <div style={{ width: "100%", flex: 1 }}>
          <Spin spin={state.loading}>
            <LineChart data={state.lineChart} />
          </Spin>
        </div>

        {/* Disabled. If re-enabled: the bar chart covers only the 18th-24th
            of the month one month back, and the pie chart that whole month -
            see `barChart()`/`pieChart()` in the server's
            maintenance.service.ts. Both sit one month back, unlike the
            fault/complaint/programme pages. */}
        {/* <div>
          <span className="title">
            Latest Month <span className="month">&mdash; {latestMonth(1)}</span>
          </span>
          <div className="latest">
            <div className="left">
              <Spin spin={state.loading}>
                <PieChart
                  data={state.pieChart}
                  labels={[
                    "Lamppost",
                    ...(disableBollard ? [] : ["Bollard"]),
                    "Controller",
                    "Cable",
                    "GSDS",
                  ]}
                />
              </Spin>
            </div>

            <div className="right">
              <Spin spin={state.loading}>
                <BarChart data={state.barChart} />
              </Spin>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};
